module.exports = __webpack_public_path__ + "imgs/ADL.e83eb1894f93ad400de38c6fec08abb8.png";